import { NavLink } from "react-router-dom"
import Faq from "./faq"
import { useEffect } from "react"
import { CONTACT_CONFIG } from '../config/contact'

export default function Use() {
    // Utilisation des variables de configuration centralisées
    const contactInfo = CONTACT_CONFIG;
    useEffect(() => {
        // Scroll to top when component mounts
        window.scrollTo(0, 0);
    }, []);

    const scrollToTop = () => {
        window.scrollTo(0, 0);
    };

    return (
        <>
            {/* Header Section */}
            <section className="bg-gradient-to-r from-[#0a1a5f] via-[#002f9c] to-[#0d47ff] text-white py-8 relative overflow-hidden">
                {/* Background Decoration */}
                <div className="absolute top-0 right-0 w-96 h-96 bg-white opacity-5 rounded-full -translate-y-48 translate-x-48"></div>
                <div className="absolute bottom-0 left-0 w-64 h-64 bg-white opacity-5 rounded-full translate-y-32 -translate-x-32"></div>
                
                <div className="h-[25vh]"></div>
                <div className="main-content relative z-10">        
                    {/* Main Title */}
                    <div className="text-center">
                        <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white leading-tight mb-3">
                            Termes et 
                            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-orange-400">
                                Conditions
                            </span>
                        </h1>
                    </div>
                    {/* Navigation Breadcrumbs */}
                    <div className="text-center mb-4">
                        <span className="text-sm">
                            <NavLink 
                                to="/" 
                                className="transition-all duration-500 hover:text-yellow-400"
                                onClick={scrollToTop}
                            >
                                Accueil
                            </NavLink> / <span className="text-gray-300">Termes et Conditions</span>
                        </span>
                    </div>
                </div>
            </section>

            {/* Content Section */}
            <section className="py-5 sm:py-12 relative overflow-hidden">
                {/* Background Pattern */}
                <div className="absolute inset-0 opacity-20">
                    <div className="h-64 w-full" style={{
                        backgroundImage: `radial-gradient(circle, #3b82f6 1px, transparent 1px)`,
                        backgroundSize: '20px 20px'
                    }}></div>
                </div>
                
                <div className="main-content w-[90%] sm:w-[90%] md:w-[85%] m-auto relative z-10">
                    <div className="space-y-8">
                        {/* Section 1 */}
                        <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-xl border border-gray-100 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">
                            <h2 className="text-xl sm:text-2xl font-bold mb-4 text-blue-900 flex items-center">
                                <div className="w-8 h-8 bg-gradient-to-br from-[#0a1a5f] to-[#002f9c] rounded-full flex items-center justify-center mr-3">
                                    <span className="text-white font-bold text-sm">1</span>
                                </div>
                                Acceptation des termes
                            </h2>
                            <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                                En accédant à notre site web et en utilisant nos services IPTV, vous acceptez ces Termes et Conditions. Si vous n'êtes pas d'accord avec ces termes, veuillez ne pas utiliser notre site ou nos services.
                            </p>
                        </div>

                        {/* Section 2 */}
                        <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-xl border border-gray-100 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">
                            <h2 className="text-xl sm:text-2xl font-bold mb-4 text-blue-900 flex items-center">
                                <div className="w-8 h-8 bg-gradient-to-br from-[#002f9c] to-[#0d47ff] rounded-full flex items-center justify-center mr-3">
                                    <span className="text-white font-bold text-sm">2</span>
                                </div>
                                Services IPTV
                            </h2>
                            <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                                
                                TVLUXO propose des abonnements IPTV pour vous permettre de profiter d'une grande variété de chaînes et de contenus. Ces abonnements sont conçus pour offrir une expérience de visionnage de qualité sans avoir besoin de collecter vos informations personnelles.
                            </p>
                            <p className="text-sm sm:text-base text-gray-600 leading-relaxed pt-2">
                                Les codes d'activation et les instructions d'installation vous seront fournis immédiatement après votre achat.
                            </p>
                        </div>

                        {/* Section 3 */}
                        <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-xl border border-gray-100 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">
                            <h2 className="text-xl sm:text-2xl font-bold mb-4 text-blue-900 flex items-center">
                                <div className="w-8 h-8 bg-gradient-to-br from-[#0d47ff] to-[#1d4ed8] rounded-full flex items-center justify-center mr-3">
                                    <span className="text-white font-bold text-sm">3</span>
                                </div>
                                Confidentialité
                            </h2>
                            <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                                Nous ne collectons aucune donnée personnelle de nos utilisateurs. Cela signifie que votre nom, adresse, informations de paiement ou tout autre détail identifiable ne sont ni collectés ni stockés par TVLUXO. Votre confidentialité est garantie, et nous avons mis en place des mesures pour empêcher toute collecte de données par des tiers.
                            </p>
                            <p className="text-sm sm:text-base text-gray-600 leading-relaxed pt-2">
                                En utilisant nos services, vous pouvez être assuré que vos activités restent complètement anonymes et sécurisées.
                            </p>
                        </div>

                        {/* Section 4 */}
                        <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-xl border border-gray-100 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">
                            <h2 className="text-xl sm:text-2xl font-bold mb-4 text-blue-900 flex items-center">
                                <div className="w-8 h-8 bg-gradient-to-br from-[#1d4ed8] to-[#3b82f6] rounded-full flex items-center justify-center mr-3">
                                    <span className="text-white font-bold text-sm">4</span>
                                </div>
                                Paiement
                            </h2>
                            <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                                Les paiements sont effectués via des plateformes sécurisées tierces. TVLUXO ne stocke aucune information de paiement. Veuillez suivre les instructions fournies pour finaliser votre achat en toute sécurité.
                            </p>
                        </div>

                        {/* Section 5 */}
                        <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-xl border border-gray-100 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">
                            <h2 className="text-xl sm:text-2xl font-bold mb-4 text-blue-900 flex items-center">
                                <div className="w-8 h-8 bg-gradient-to-br from-[#3b82f6] to-[#60a5fa] rounded-full flex items-center justify-center mr-3">
                                    <span className="text-white font-bold text-sm">5</span>
                                </div>
                                Utilisation des services
                            </h2>
                            <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                                Les services IPTV fournis par TVLUXO sont destinés uniquement à un usage personnel. Vous ne devez pas partager, redistribuer ou revendre les codes d'activation ou le contenu fourni par nos services. Toute utilisation abusive peut entraîner la résiliation de votre abonnement sans remboursement.
                            </p>
                        </div>

                        {/* Section 6 */}
                        <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-xl border border-gray-100 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">
                            <h2 className="text-xl sm:text-2xl font-bold mb-4 text-blue-900 flex items-center">
                                <div className="w-8 h-8 bg-gradient-to-br from-[#60a5fa] to-[#93c5fd] rounded-full flex items-center justify-center mr-3">
                                    <span className="text-white font-bold text-sm">6</span>
                                </div>
                                Responsabilité
                            </h2>
                            <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                                TVLUXO s'engage à fournir des services IPTV de haute qualité. Cependant, nous ne pouvons garantir une disponibilité ininterrompue en raison de facteurs externes tels que des pannes Internet ou des problèmes techniques. Nous déclinons toute responsabilité pour les interruptions indépendantes de notre volonté.
                            </p>
                        </div>

                        {/* Section 7 */}
                        <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-xl border border-gray-100 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">
                            <h2 className="text-xl sm:text-2xl font-bold mb-4 text-blue-900 flex items-center">
                                <div className="w-8 h-8 bg-gradient-to-br from-[#93c5fd] to-[#bfdbfe] rounded-full flex items-center justify-center mr-3">
                                    <span className="text-white font-bold text-sm">7</span>
                                </div>
                                Droits de propriété intellectuelle
                            </h2>
                            <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                                Tout le contenu fourni par nos services IPTV, y compris les chaînes, films et séries, est protégé par des droits d'auteur et des lois sur la propriété intellectuelle. Vous ne devez pas enregistrer, distribuer ou copier ce contenu.
                            </p>
                        </div>

                        {/* Section 8 */}
                        <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-xl border border-gray-100 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">
                            <h2 className="text-xl sm:text-2xl font-bold mb-4 text-blue-900 flex items-center">
                                <div className="w-8 h-8 bg-gradient-to-br from-[#bfdbfe] to-[#dbeafe] rounded-full flex items-center justify-center mr-3">
                                    <span className="text-white font-bold text-sm">8</span>
                                </div>
                                Modifications des termes
                            </h2>
                            <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                                Nous nous réservons le droit de modifier ces termes à tout moment. Toute modification sera publiée sur notre site web. En continuant à utiliser nos services après une modification, vous acceptez les nouvelles conditions.
                            </p>
                        </div>

                        {/* Section 9 */}
                        <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-xl border border-gray-100 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">
                            <h2 className="text-xl sm:text-2xl font-bold mb-4 text-blue-900 flex items-center">
                                <div className="w-8 h-8 bg-gradient-to-br from-[#dbeafe] to-[#eff6ff] rounded-full flex items-center justify-center mr-3">
                                    <span className="text-white font-bold text-sm">9</span>
                                </div>
                                Contactez-nous
                            </h2>
                            <p className="text-sm sm:text-base text-gray-600 leading-relaxed mb-4">
                                Pour toute question concernant ces termes et conditions ou pour exercer vos droits, 
                                vous pouvez nous contacter via :
                            </p>
                            <ul className="list-disc list-inside space-y-2 text-sm sm:text-base text-gray-600">
                                <li>Email : {contactInfo.email}</li>
                                <li>
                                    WhatsApp :{" "}
                                    <a 
                                        href={contactInfo.whatsappUrl} 
                                        target="_blank" 
                                        rel="noopener noreferrer" 
                                        className="text-blue-600 underline hover:text-blue-800 transition-colors duration-300"
                                    >
                                        Cliquez ici pour nous contacter
                                    </a>
                                </li>
                            </ul>
                        </div>

                        {/* Conclusion */}
                        <div className="bg-gradient-to-r from-[#0a1a5f] to-[#002f9c] rounded-2xl p-6 sm:p-8 text-white shadow-xl">
                            <div className="text-center">
                                <h3 className="text-lg sm:text-xl font-bold mb-4">
                                    Merci d'avoir choisi {contactInfo.companyName}
                                </h3>
                                <p className="text-sm sm:text-base leading-relaxed opacity-90">
                                    Nous sommes fiers de garantir votre confidentialité et de vous offrir 
                                    un service de haute qualité sans compromettre votre sécurité ou votre anonymat.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <Faq/>
            </section>
            
        </>
    )
}   
